import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';

const url = `${PREFIX_URL}/v01/inbox/upload`;

type UploadInlineImageResponse = {
  data: {
    results: {
      filename: string;
      origin: string;
      id: string;
      size: string;
    }[];
  };
};

export type UploadInlineImageDTO = FormData;

export const uploadInlineImage = (
  formData: UploadInlineImageDTO
): Promise<UploadInlineImageResponse> => {
  return axios.post(url, formData);
};

type useUploadInlineImageOptions = {
  config?: MutationConfig<typeof uploadInlineImage>;
};

export const useUploadInlineImage = ({ config }: useUploadInlineImageOptions) => {
  return useMutation({
    ...config,
    mutationFn: uploadInlineImage,
  });
};
